import React from 'react';
import Lottie from 'react-lottie';
import animationData from './loader.json'; 

const Loader = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true, 
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: '#f5f5f5'
    }}>
      <div style={{ width: 300, height: 300 }}>
        <Lottie 
          options={defaultOptions}
        />
      </div>
    </div>
  );
};

export default Loader;